import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callAPIWithoutAuth } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

export const fetchProductById = createAsyncThunk(
    'productDetails/fetchProductById',
    async (productId, { rejectWithValue, getState }) => {
        try {
            const state = getState();
            const userId = state.auth?.user?.id;
            if (!productId) {
                return rejectWithValue('Product ID is required');
            }

            const response = await callAPIWithoutAuth(
                `${apiUrls.productView}/${productId}/${userId}`,
                {},
                "GET",
                {}
            );

            if (response?.data?.success) {
                return {
                    product: response.data.product,
                    related_products: response.data.related_products || [],
                    reviews: response.data.reviews || [],
                    reviews_count: response.data.reviews_count,
                    average_rating: response.data.average_rating

                };
            } else {
                return rejectWithValue(response?.data?.message || 'Failed to fetch product');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Network error');
        }
    }
);

const productDetailSlice = createSlice({
    name: 'productDetails',
    initialState: {
        product: null,
        loading: false,
        relatedProducts: [],
        reviews: [],
        reviews_count: 0,
        average_rating: 0,
        productLoading: false,
        error: null,
        productError: null,
         printingMethods: [], 
    },
    reducers: {
        clearProductError: (state) => {
            state.error = null;
            state.productError = null;
            state.relatedError = null;
            state.reviewError = null;
        },
        clearProduct: (state) => {
            state.product = null;
        },
        clearRelatedProducts: (state) => {
            state.relatedProducts = [];
        },
        clearReviewProducts: (state) => {
            state.reviews = [];
        },
        resetProductState: (state) => {
            state.product = null;
            state.relatedProducts = [];
            state.reviews = [];
            state.reviews_count = 0;
            state.average_rating = 0;
            state.loading = false;
            state.productLoading = false;
            state.relatedLoading = false;
            state.reviewLoading = false;
            state.error = null;
            state.productError = null;
            state.relatedError = null;
            state.reviewError = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductById.pending, (state) => {
                if (state.product === null) {
                    state.productLoading = true;
                    state.loading = true;
                }
                state.productError = null;

            })
            .addCase(fetchProductById.fulfilled, (state, action) => {
                state.productLoading = false;
                state.loading = false;
                state.product = action.payload.product;
                state.relatedProducts = action.payload.related_products;
                state.reviews = action.payload.reviews;
                state.average_rating = action.payload.average_rating;
                state.reviews_count = action.payload.reviews_count
                 state.printingMethods = action.payload.product?.printing_methods || [];
                state.productError = null;
            })
            .addCase(fetchProductById.rejected, (state, action) => {
                state.productLoading = false;
                state.loading = false;
                state.productError = action.payload;
                state.error = action.payload;
            });
    }
});

export const {
    clearProductError,
    clearProduct,
    clearRelatedProducts,
    resetProductState
} = productDetailSlice.actions;
export default productDetailSlice.reducer;